import { Icon } from "@iconify/react/dist/iconify.js";
import TextSlider from "./TextSlider";
import { Link } from "react-router-dom";

function Pricing() {
  const data = {
    data: [
      {
        planName: "Standard",
        planPrice: "$699/month",
        planDescp:
          "Ideal for startups and small businesses taking their first steps online.",
        planIncludes: [
          "Competitive research & insights",
          "Wireframing and prototyping",
          "Basic tracking setup",
          "Standard contact form integration",
        ],
      },
      {
        planName: "Premuim",
        // tag: "Most popular",
        // planPrice: "Pour plus d'informations, veuillez nous contacter",
        // cancelPrice: "Nous contacter",
        contact: "Pour plus d'informations, veuillez nous contacter",
        planDescp:
          "Perfect for growing brands needing more customization and flexibility.",
        planIncludes: [
          "Competitive research & insights",
          "Wireframing and prototyping",
          "Basic tracking setup",
          "Standard contact form integration",
        ],
      },
    ],
    partnerLogo: [
      {
        light: "/images/home/pricing/partner-1.svg",
      },
      {
        light: "/images/home/pricing/partner-2.svg",
      },
      {
        light: "/images/home/pricing/partner-3.svg",
      },
      {
        light: "/images/home/pricing/partner-4.svg",
      },
      {
        light: "/images/home/pricing/partner-5.svg",
      },
    ],
  };

  return (
    <section className="bg-lightgray py-10 md:py-20 justify-center">
      <div className="flex flex-col">
        <div className="container">
          <div className="flex flex-col gap-3">
              <div className="flex flex-row gap-4">
                <img src="/images/Icon/line.png" alt="Images" width={60} />
                <p className="flex justify-start items-center uppercase tracking-[2px] font-['Jost'] text-[10px] sm:text-[15px]">
                  Nos Offres
                </p>
              </div>
            </div>
          <div className="flex flex-col lg:mx-8">
            <div className="grid md:grid-cols-2 md:px-8">
              {data?.data?.map((value, index) => {
                return (
                  <div key={index}>
                    <div className="flex flex-row justify-center">
                      <img
                        className="w-[40px] h-[40px] 
                          sm:w-[55px] sm:h-[55px]
                          [680px]:w-[32px] [720px]:h-[32px]
                          md:w-[55px] md:h-[55px]
                          lg:w-[60px] lg:h-[60px]
                          xl:w-[70px] xl:h-[70px]
                          2xl:w-[80px] 2xl:h-[80px] object-contain"
                        src="/images/home/pricing/lys.png"
                      />
                    </div>
                    <div className="bg-[#fff6e2] justify-center border-[#a53913] border-[4px] sm:border-[6px] md:border-[5px] mt-[-4px] md:mt-[-5px] lg:mt-[-6px] rounded-2xl p-3 sm:p-5 xl:p-4 flex flex-col mx-4 lg:mx-10">
                      <div className="flex flex-col">
                        <div className="flex gap-4">
                          <p className="font-medium items-center text-[20px] sm:text-[25px] md:text-[30px]">
                            {value?.planName}
                          </p>
                          {value?.tag && (
                            <div className="flex items-center gap-2 bg-[#ad3500] w-fit px-3 rounded-full">
                              <Icon
                                icon="fluent:fire-20-regular"
                                width="15"
                                height="20"
                                style={{ color: "#fff" }}
                              />
                              <span className="text-white text-[13px] sm:text-[18px] lg:text-[20px]">
                                {value?.tag}
                              </span>
                            </div>
                          )}
                        </div>
                        <div>
                          <div className="flex items-center gap-2 mt-4">
                            {value.cancelPrice && (
                              <h3 className="text-secondary/40">
                                <del>{value.cancelPrice}</del>
                              </h3>
                            )}
                            <p className="text-[15px] sm:text-[20px] md:text-[25px]">{value.planPrice}</p>
                            {/* <span className="text-base text-secondary/70">
                              /month
                            </span> */}
                          </div>
                        </div>
                        <p className="text-[15px] sm:text-[20px] md:text-[15px] lg:text-[20px]">{value.contact}</p>
                        <p className="mt-4 text-[12px] sm:text-[15px] md:text-[15px] max-w-[270px] text-secondary/70">
                          {value.planDescp}
                        </p>
                      </div>
                      <div className="pt-3 sm:pt-6 md:pt-2 border-t border-secondary/12">
                        <p className="text-base pb-5">What’s Included:</p>
                        <div>
                          <ul className="flex flex-col gap-3">
                            {value?.planIncludes?.map((item, index) => {
                              return (
                                <li
                                  key={index}
                                  className="flex items-center gap-1.5 sm:gap-4"
                                >
                                  <div className="bg-[#ad3500] w-[20px] sm:w-[25px] md:w-[30px] p-1 sm:p-1.5 rounded-full flex-shrink-0">
                                    <img
                                      src="/images/Icon/right-check.png"
                                      alt="right-icon"
                                      width={30}
                                      height={30}
                                    />
                                  </div>
                                  <span className="flex-1 text-[12px] sm:text-[15px] md:text-[18px]">
                                    {item}
                                  </span>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                      <div className="flex justify-center pt-5">
                        <Link
                          href="/"
                          className="group relative flex justify-start hover:justify-end items-center w-[150px] h-[30px] md:w-[200px] md:h-[40px] bg-[#ad3500] hover:bg-secondary rounded-full transition-all duration-300 ease-in-out"
                        >
                          <span className="py-4 px-4 text-[10px] md:text-[13px] font-bold text-[#fff6e2] group-hover:text-white transition-all duration-300 ease-in-out">
                            Envoyer ma demande
                          </span>
                          <div className="absolute right-1 transition-all duration-300 ease-in-out group-hover:left-0">
                            <svg
                              className="flex items-center transition-transform duration-300 ease-in-out group-hover:rotate-45"
                              width="25"
                              height="45"
                              viewBox="0 0 58 58"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g filter="url(#filter0_d_1_873)">
                                <rect
                                  x="3"
                                  y="2"
                                  width="52"
                                  height="52"
                                  rx="26"
                                  fill="white"
                                />
                                <path
                                  d="M24 23H34M34 23V33M34 23L24 33"
                                  stroke="#1F2A2E"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </g>
                              <defs>
                                <filter
                                  id="filter0_d_1_873"
                                  x="0"
                                  y="0"
                                  width="58"
                                  height="58"
                                  filterUnits="userSpaceOnUse"
                                  colorInterpolationFilters="sRGB"
                                >
                                  <feFlood
                                    floodOpacity="0"
                                    result="BackgroundImageFix"
                                  />
                                  <feColorMatrix
                                    in="SourceAlpha"
                                    type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                    result="hardAlpha"
                                  />
                                  <feOffset dy="1" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix
                                    type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                                  />
                                  <feBlend
                                    mode="normal"
                                    in2="BackgroundImageFix"
                                    result="effect1_dropShadow_1_873"
                                  />
                                  <feBlend
                                    mode="normal"
                                    in="SourceGraphic"
                                    in2="effect1_dropShadow_1_873"
                                    result="shape"
                                  />
                                </filter>
                              </defs>
                            </svg>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="flex flex-col gap-10 mt-10">
            <TextSlider text="Vous pourez nous retrouver sur booking et airbnb via les liens ci dessous ↓"/>
          </div>
        </div>
      </div>
      {/* </div> */}
    </section>
  );
}

export default Pricing;
